import { render, staticRenderFns } from "./Revolution.vue?vue&type=template&id=70d23ce2&scoped=true&lang=pug&"
import script from "./Revolution.ts?vue&type=script&lang=ts&"
export * from "./Revolution.ts?vue&type=script&lang=ts&"
import style0 from "./Revolution.vue?vue&type=style&index=0&id=70d23ce2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d23ce2",
  null
  
)

export default component.exports